module.exports = __webpack_public_path__ + "img/404.206586d2.png";